import { render, staticRenderFns } from "./menuNumC.vue?vue&type=template&id=4f8cff5d&scoped=true"
import script from "./menuNumC.vue?vue&type=script&lang=js"
export * from "./menuNumC.vue?vue&type=script&lang=js"
import style0 from "./menuNumC.vue?vue&type=style&index=0&id=4f8cff5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8cff5d",
  null
  
)

export default component.exports